import Vue from 'vue'
import Vuex from 'vuex'
import optionType from './modules/option/type'
import option from './modules/option'
import { registerDelivery, unregisterDelivery } from './registerDelivery'

Vue.use(Vuex)

const modules = {}
const requireContext = require.context('./modules', true, /.*\/$/)
requireContext.keys().forEach((file) => {
    modules[file.replace(/\.|\//g, '')] = requireContext(file).default
})

const store = new Vuex.Store({ modules })

const selectTypes = Object.values(optionType.optionTypes)
for (let type of selectTypes) {
    store.registerModule(optionType.getModuleName(type), option(type))
}
// store.router = router
store.registerDelivery = registerDelivery
store.unregisterDelivery = unregisterDelivery

export default store
